;(function () {
  const components = {
    fabricDetailsNavigation: SAXX.Init.Component((node) => {
      const sections = node.querySelectorAll('.fabric-details--section')
      const navLinks = node.querySelectorAll('.nav--item')

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              navLinks.forEach((link) => link.classList.remove('active'))
              node
                .querySelector(`a[href*=${entry.target.id}]`)
                .classList.add('active')
            }
          })
        },
        { threshold: 1 },
      )

      sections.forEach((section) => observer.observe(section))
    }),
  }
  SAXX.Init.AddComponents(components)
})()
